import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-scroll';

// 委員会一覧ページ 在宅勤務（リモートワーク）タブ
function Contents1() {

  const baseUrl = process.env.REACT_APP_PUBLIC_URL;

  return (
    <div id="committee-content1">
      <h2 className="tag-title">在宅勤務（リモートワーク）</h2>
      <Row className="toc-btnArea">
        <Col sm={4} className='toc-btn'>
          <Link
            to="chapter01"
            smooth={true}
            duration={500}
            offset={-100}
            className='btn main-btn type-internal w-100'
          >
            在宅勤務制度
          </Link>
        </Col>
        <Col sm={4} className='toc-btn'>
          <Link
            to="chapter02"
            smooth={true}
            duration={500}
            offset={-100}
            className='btn main-btn type-internal w-100'
          >
            通常リモートワーク
          </Link>
        </Col>
        <Col sm={4} className='toc-btn'>
          <Link
            to="chapter03"
            smooth={true}
            duration={500}
            offset={-100}
            className='btn main-btn type-internal w-100'
          >
            臨時リモートワーク
          </Link>
        </Col>
      </Row>
      <h3 id="chapter01" className='icon-title type-pencil mt-small'>在宅勤務制度</h3>
      <p>在宅勤務（リモートワーク）は、自宅で業務を行うワークスタイルです。<br />Zenkenでは、2つの在宅勤務の方法を設けています。</p>
      <div className="committee-related">
        <div className="point-list-border no-title mb-3">
          <ul className="dot-list type-list">
            <li>通常リモートワーク：出社頻度週１回以下のリモートワーク（原則在宅）</li>
            <li>臨時リモートワーク：通常リモートワーク以外で実施するリモートワーク（原則出社）</li>
          </ul>
        </div>
        <p>※リモートワークに当たり、特別な手当はありません。<br />※みなし残業代支給の社員は1日のみなし残業時間（1時間）を超える残業はNG。また、残業前に
          ジンジャーにて残業申請を必ず行ってください。みなし残業代が支給されていない社員は残業自体NG。</p>

        <h3 id="chapter02" className='icon-title type-pencil mt-small'>通常リモートワーク</h3>
        <p>通常リモートは「出社頻度週１回以下のリモートワーク」を指します。通常リモートの方には、定期代を支給せず、当月の出社日数実績に応じてIC料金で計算した通勤費を翌月の給与と共に支給します。</p>
        <div className="point-list-border mb-3">
          <div className="point-title">
            <span>CHECK</span>通常リモートの申請について
          </div>
          <ol>
            <li>通常リモートワークは、上長（マネジャー以上）との面談※が必須です。
              <br />※上長面談には部署により一定の基準がありますので、上長にご確認ください。</li>
            <li>タレントパレットより、「<a href='https://tvyj3455.talent-p.net/ApprovalProcessRequestFormMng/Index?url_token=52caa8218e424ddab00eef849e07fb23' className='text-link type-external' target='_blank'>リモートワーク申請</a>」をお願いいたします。
            </li>
            <li>jinjerの「スケジュール申請」にて「リモ」と付いたテンプレートで申請をお願いいたします。</li>
            <li>承認後、リモートワークへ。jinjerの「打刻区分：リモートワーク」で打刻してください。</li>
            <li>リモートを継続する場合※は改めて申請を行ってください（１回の更新で最長3ヶ月）。
              <br />※生産性低下等の上長判断により、継続不可となることもあります。</li>
          </ol>
          <p>必ず下記の規定を確認してから申請してください。</p>
          <Row className="mt-5">
            <Col sm={6}>
              <a
                href="https://sites.google.com/zenken.co.jp/contracts-regulations/regulations/regulations_related_to_personnel_and_labor_affairs/Telecommuting-Regulations?authuser=0"
                target="_blank"
                className="btn main-btn type-external"
              >
                在宅勤務規程
              </a>
            </Col>
          </Row>
        </div>

        <div className="point-list-border mb-3">
          <div className="point-title">
            <span>CHECK</span>リモートワーク出退勤時の必須事項
          </div>
          <p className="type-list">
            出社と区別をするために、jinjerでの打刻時に、「打刻区分：リモートワーク」に必ずチェックを入れて出勤、退勤打刻を行ってください。
          </p>
          <p>通常リモート勤務の場合、「打刻区分：リモートワーク」の打刻実績により通勤手当が計算されます。打刻実績が誤っていた場合、通勤手当の誤支給となるのでご注意ください。</p>
          <p>もし「打刻区分を間違えていた！」というときは、打刻修正申請をお願いします。<br />下記マニュアルをご参照ください。</p>
          <Row className="mt-5">
            <Col sm={6}>
              <a
                href="https://www.ztree.cfbx.jp/info-wp/wp-content/uploads/2024/03/%E5%9C%A8%E5%AE%85%E5%8B%A4%E5%8B%99%E5%8C%BA%E5%88%86%E9%81%8B%E7%94%A8%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB.pdf"
                target="_blank"
                className="btn main-btn type-external"
              >
                在宅勤務区分運用マニュアル
              </a>
            </Col>
          </Row>
        </div>

        <div className="point-list-border mb-3">
          <div className="point-title">
            <span>CHECK</span>リモートワーク時の通勤費について
          </div>
          <p className="type-list">
            実費支給 （上限1日3,000円）※現時点で1日3,000円超過の社員は変更なし。
          </p>
        </div>

        <div className="point-list-border mb-3">
          <div className="point-title">
            <span>CHECK</span>更新手続きについて
          </div>
          <p>年に１回、<a href="https://tvyj3455.talent-p.net/ApprovalProcessRequestFormMng/Index?url_token=cab47ca740074ce995435aaab1e5aa36" className='text-link type-external' target='_blank'>タレントパレットの「リモートワーク誓約書」</a>申請をお願いいたします。
          </p>
        </div>

        <h3 id="chapter03" className='icon-title type-pencil mt-small'>臨時リモートワーク</h3>
        <p>臨時リモートは、通常リモート以外で実施するリモートワーク（原則出社）です。
        </p>
        <div className="point-list-border mb-3">
          <div className="point-title">
            <span>CHECK</span>臨時リモートの申請について
          </div>
          <ol>
            <li>jinjerの「スケジュール申請」より、「リモ」と追加テンプレートで申請をお願いいたします。
            </li>
            <li>承認後、リモートワークへ。jinjerの「打刻区分：リモートワーク」で打刻してください。
            </li>
          </ol>
          <p>※通常出勤と区別をするために、ジンジャーでの打刻時に、打刻区分で「在宅勤務」に必ずチェックを入れて出勤、退勤打刻を行ってください。</p>
        </div>

        <div className="point-list-border mb-3">
          <div className="point-title">
            <span>CHECK</span>リモートワーク時の通勤費について
          </div>
          <p className="type-list">
            定期代支給 （1ケ月の半数以上がリモートワークの場合、定期代の返金を求める場合あり）
          </p>
        </div>

        <div className="point-list-border mb-3">
          <div className="point-title">
            <span>CHECK</span>更新手続きについて
          </div>
          <p className="type-list">
            年に１回、<a href="https://tvyj3455.talent-p.net/ApprovalProcessRequestFormMng/Index?url_token=cab47ca740074ce995435aaab1e5aa36" className='text-link type-external' target='_blank'>タレントパレットの「リモートワーク誓約書」</a>申請をお願いいたします。
          </p>
        </div>

      </div>
    </div >
  );
}

export default Contents1;